export default     {
    prompt:"Heading Font",
    field:"--headingFont",
    type:"style",
    fontSelector:true,
    default:"inherit"
}